import script from "./NewsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsSection.vue?vue&type=script&lang=ts&setup=true"

import "./NewsSection.vue?vue&type=style&index=0&id=3ceb2237&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ceb2237"]])

export default __exports__